"use client";

import { Card, CardHeader } from "components/ui/v2";
import useTranslation from "next-translate/useTranslation";
import type { IRecognition } from "types/Recognition.type";
import { RecognitionValueCardV2 } from "./RecognitionValueCardV2";

export interface RecognitionsListV2Props {
  recognitions: IRecognition[] | undefined;
  enableSeeValues?: boolean;
  userId?: string;
}

export function RecognitionsListV2({
  recognitions,
  enableSeeValues = true,
  userId = "",
}: RecognitionsListV2Props) {
  const { t } = useTranslation("common");
  const items = Array.isArray(recognitions) ? recognitions : [];

  return (
    <div className="space-y-6">
      <Card size="full">
        <CardHeader
          title={t("Reconocimientos recibidos")}
          description={t("Revisa los reconocimientos recibidos hasta ahora")}
        />
        <div className="px-8 pb-8 pt-6 sm:px-10 sm:pb-10 sm:pt-8">
          <div className="flex flex-wrap gap-4 is1140:grid is1140:grid-cols-3">
            {items.map((recognition) => (
              <RecognitionValueCardV2
                key={`received-${recognition.corporateValueId}`}
                corporateValueId={recognition.corporateValueId}
                srcImage={recognition.avatar || null}
                title={recognition.corporateValueTitle}
                quantity={recognition.quantityReceived || 0}
                enableSeeValues={enableSeeValues}
                userId={userId}
                type="received"
              />
            ))}
          </div>
        </div>
      </Card>

      <Card size="full">
        <CardHeader
          title={t("Reconocimientos enviados")}
          description={t("Revisa los reconocimientos has enviado")}
        />
        <div className="px-8 pb-8 pt-6 sm:px-10 sm:pb-10 sm:pt-8">
          <div className="grid w-full overflow-hidden">
            <div className="flex gap-4 overflow-auto" id="scrollable-blue">
              {items.map((recognition) => (
                <RecognitionValueCardV2
                  key={`sent-${recognition.corporateValueId}`}
                  corporateValueId={recognition.corporateValueId}
                  srcImage={recognition.avatar || null}
                  title={recognition.corporateValueTitle}
                  quantity={recognition.quantitySend || 0}
                  enableSeeValues={enableSeeValues}
                  userId={userId}
                  type="sent"
                />
              ))}
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
}
